import { GtmHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { GtmSendEventInput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { FormatHelper } from '@bcp-channels-sharedcomponents-reactjs/utils';
import { useGetCurrentBreakpoint, useGetValueByCreditType } from '@hooks';
import { useServicesStore, useSessionInfo, useSimulationId } from '@store';

export interface GtmHook {
	sendEvent: (data: GtmSendEventInput, sendAmounts?: boolean) => void;
}

export const useGtm = (): GtmHook => {
	const simulationId = useSimulationId();
	const { isMobile } = useGetCurrentBreakpoint();
	const sessionInfo = useSessionInfo();
	const simulationOverview = useServicesStore((state) => state.simulationOverview);

	// cSpell: disable
	const itemType = useGetValueByCreditType(
		{
			CL: 'credito-pessoal',
			AL: 'credito-auto',
			RENEN: 'credito-edificios-sustentaveis',
			ALEV: 'credito-eletricauto',
			HOME: 'credito-lar',
			AN: 'credito-auto-novos',
			CONSTR: 'credito-obras',
			EDUCA: 'credito-educacao',
			HEALTH: 'credito-saude',
		},
		'credito-pessoal'
	);

	const sendEvent = (data: GtmSendEventInput, sendAmounts = false) => {
		const amounts = {
			amount_desired: (simulationOverview?.requestedAmount || 0).toString(),
			total_months: (simulationOverview?.totalDuration || 0).toString(),
			monthly_payment: (simulationOverview?.repaymentPeriods?.length
				? simulationOverview?.repaymentPeriods[0].installement || 0
				: 0
			)?.toString(),
			mtic: (simulationOverview?.totalLoanCost || 0).toString(),
			taeg: (simulationOverview?.effectiveAnnualInterestRate || 0).toString(),
			tan: (simulationOverview?.repaymentPeriods?.length
				? FormatHelper.formatNumber(simulationOverview?.repaymentPeriods[0].interestRate || 0, 'noformat', 3)
				: 0
			).toString(),
		};

		GtmHelper.sendEvent({
			item_category: 'credito',
			item_type: itemType,
			screen_name: `${itemType}/simulador-publico`,
			event: data?.firebaseEventName || 'custom_event',
			firebaseEventName: data?.firebaseEventName || 'custom_event',
			device_plat: isMobile ? 'mobile' : 'desktop',
			environment: 'public',
			language: sessionInfo?.language?.toLowerCase() || 'pt',
			param_08: simulationId?.toString() || '',
			...((sendAmounts && amounts) || {}),
			...data,
		});
	};
	// cSpell: enable

	return {
		sendEvent,
	};
};
